// extracted by mini-css-extract-plugin
export default {"hourglass":"styles_hourglass__AKjqF","spin":"styles_spin__5TEmi"};